import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../PlaylistSlider/slider.module.css";
import next from "../../images/next.svg";
import prev from "../../images/prev.svg";
import { Link } from "react-router-dom";
import OppComponent from "./oppComponent";
import Carousel from "nuka-carousel/lib/carousel";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div onClick={onClick}>
      <img src={next} alt="" className={className} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div onClick={onClick}>
      <img src={prev} alt="" className={className} />
    </div>
  );
}

function oppSlider({
  heading,
  playlist,
  info = undefined,
  setSelectedOpportunity,
  openModal,
}) {
  let width = window.innerWidth;

  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: width < 768 ? 1 : 4,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 1500,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: true,
  };

  return (
    <div className={styles.container2}>
      <div className="seller-carousal py-6">
        <Carousel
          slidesToShow={width > 768 ? 6 : width > 632 ? 3 : 2}
          renderCenterLeftControls={({ previousSlide }) => (
            <button
              onClick={previousSlide}
              className="max-sm:text-[15px] max-sm:w-6 max-sm:h-6  text-[22px] w-8 h-8     flex jusitfy-center items-center rounded-full  hover:text-[#454598] focus:outline-none"
            >
              <p className=" flex jusitfy-center  items-center mx-auto my-auto hover:font-[1000] ">
                <span className=""> {"<"}</span>
              </p>
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button
              onClick={nextSlide}
              className="max-sm:text-[15px] max-sm:w-6 max-sm:h-6  text-[22px] w-8 h-8     flex jusitfy-center items-center rounded-full  hover:text-[#454598] focus:outline-none"
            >
              <p className=" flex jusitfy-center items-center mx-auto my-auto hover:font-[1000] ">
                <span> {">"}</span>
              </p>
            </button>
          )}
        >
          {playlist &&
            playlist.map((item) => {
              return (
                <OppComponent
                  key={item._id}
                  opportunity={item}
                  setSelectedOpportunity={setSelectedOpportunity}
                  openModal={openModal}
                />
              );
            })}
        </Carousel>
      </div>
      {/* <h2 className={styles.heading}>{heading}</h2>
      <Slider {...settings} className={styles.slider2}>
        {playlist &&
          playlist.map((item) => {
            return (
              <OppComponent
                key={item._id}
                opportunity={item}
                setSelectedOpportunity={setSelectedOpportunity}
                openModal={openModal}
              />
            );
          })}
      </Slider> */}
    </div>
  );
}

export default oppSlider;
